var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE121",
    cx: 32,
    cy: 32,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 15.2v21.6c-5.9-.1-10.7-5.1-10.5-11 0-5.8 4.7-10.4 10.5-10.6 0 .1 0 0 0 0zm2.8 33.5V27.2c5.9.1 10.7 5.1 10.5 11 0 5.8-4.7 10.4-10.5 10.5zm5.1-33.5c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.1-5.1 5.1-5.1-2.3-5.1-5.1 2.3-5.1 5.1-5.1zm-13 23.4c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.1-5.1 5.1-5.1-2.3-5.1-5.1 2.3-5.1 5.1-5.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbIcon);
export default __webpack_public_path__ + "static/media/sb-icon.4a618cfc3d70aa46b722ed4196ca299e.svg";
export { ForwardRef as ReactComponent };